import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-unit',
  imports: [UnderConstructionComponent],
  templateUrl: './unit.component.html'
})
export class UnitComponent {}
